export default {"src":"/_next/static/media/MobilefashionEnthem.759ff234.svg","height":100,"width":375};